import { render, staticRenderFns } from "./HistoryPSList.vue?vue&type=template&id=7147fdc9&scoped=true"
import script from "./HistoryPSList.ts?vue&type=script&lang=ts&external"
export * from "./HistoryPSList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147fdc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7147fdc9')) {
      api.createRecord('7147fdc9', component.options)
    } else {
      api.reload('7147fdc9', component.options)
    }
    module.hot.accept("./HistoryPSList.vue?vue&type=template&id=7147fdc9&scoped=true", function () {
      api.rerender('7147fdc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/LOPD/components/HistoryPSList/HistoryPSList.vue"
export default component.exports